import React from 'react';
import { useQuery } from 'react-query';

import { fetchFromFirebase } from '../../hooks/fetchFromFirebase';

 // Fetch Slider Dealer Info
 const DealerInfoSection = ({ collection, id }) => {
    const { isLoading, isError, data, error } = useQuery(['Dealer Info Text', collection, id], () => fetchFromFirebase('dealerInfo', 'KD6FHhBRkM5ISPT8qTRZ'));
  
    if (isLoading) {
      return <div>Loading...</div>;
    }
  
    if (isError) {
      return <div>Error: {error.message}</div>;
    }
  
    return (
        <div id='dealer-info-section' className='container padding-vert-80-40'>

            <h3 className='fw-900 ta-center'>{data.dealerName}</h3>

            <div dangerouslySetInnerHTML={{__html: data?.dealerInfoText}} />

        </div>
    );
};

export default DealerInfoSection;